import { Directive, HostListener, EventEmitter, Output, Renderer2, ElementRef } from '@angular/core';

@Directive({ selector: '[appFileDrop]' })
export class FileDropDirective {
    // tslint:disable-next-line: no-output-on-prefix
    @Output() onDrop = new EventEmitter<File[]>();

    constructor(
        private element: ElementRef,
        private renderer: Renderer2
    ) { }

    @HostListener('dragstart', ['$event'])
    public dragStart(_event) {
        this.addClass();
    }

    @HostListener('dragenter', ['$event'])
    @HostListener('dragover', ['$event'])
    public dragOver(event) {
        event.preventDefault();
        this.addClass();
    }

    @HostListener('dragexit', ['$event'])
    @HostListener('dragleave', ['$event'])
    public dragEnd(event) {
        event.preventDefault();
        this.removeClass();
    }

    @HostListener('drop', ['$event'])
    public drop(event: DragEvent) {
        event.preventDefault();
        this.removeClass();

        if (event.dataTransfer.files.length > 0) {
            const files: File[] = [];
            for (let i = 0; i < event.dataTransfer.files.length; i++) {
                files.push(event.dataTransfer.files.item(i));
            }

            this.onDrop.emit(files);
        }
    }

    private addClass() {
        this.renderer.addClass(this.element.nativeElement, 'bg-secondary');
        this.renderer.addClass(this.element.nativeElement, 'bg-info');
    }

    private removeClass() {
        this.renderer.removeClass(this.element.nativeElement, 'bg-secondary');
        this.renderer.removeClass(this.element.nativeElement, 'bg-info');
    }
}
